// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"d712d1a0","197":"d55e23ad","357":"364052ab","647":"08b6bd27","707":"821bcfe4"}[chunkId] + ".chunk.js";
};